//#region src/transports/const.ts
let TransportItemType = /* @__PURE__ */ function(TransportItemType) {
	TransportItemType["EXCEPTION"] = "exception";
	TransportItemType["LOG"] = "log";
	TransportItemType["MEASUREMENT"] = "measurement";
	TransportItemType["TRACE"] = "trace";
	TransportItemType["EVENT"] = "event";
	return TransportItemType;
}({});
const transportItemTypeToBodyKey = {
	["exception"]: "exceptions",
	["log"]: "logs",
	["measurement"]: "measurements",
	["trace"]: "traces",
	["event"]: "events"
};
//#endregion
export { TransportItemType, transportItemTypeToBodyKey };

//# sourceMappingURL=const.js.map